import { cn } from "@/src/js/lib/utils";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";
import { formatNumber } from "../utils";
import { CardNotes } from "../CardNotes";

interface NumberCardProps {
  title: string;
  description?: string;
  notes?: string[];
  focusDataNumber: number | string | null;
  comparisonDataNumber: number | string | null;
  focusDataUnit?: string;
  comparisonDataUnit?: string;
  focusSubtitle?: string;
  comparisonSubtitle?: string;
  trendIconClass?: string;
  decimalPlaces?: number;
}

export function NumberCard({
  title,
  description,
  notes,
  focusDataNumber,
  comparisonDataNumber,
  focusDataUnit,
  comparisonDataUnit,
  focusSubtitle,
  comparisonSubtitle,
  trendIconClass,
  decimalPlaces,
}: NumberCardProps) {
  const formatCardNumber = (num: number | string | null) =>
    typeof num === "number" ? formatNumber(num, decimalPlaces) : num;

  const formattedFocusDataNumber = formatCardNumber(focusDataNumber);
  const formattedComparisonDataNumber = formatCardNumber(comparisonDataNumber);

  return (
    <Card className="tw:h-full">
      <CardHeader>
        <CardTitle>{title}</CardTitle>
        {description && <CardDescription>{description}</CardDescription>}
        <CardNotes notes={notes} />
      </CardHeader>
      <CardContent>
        <div className="tw:text-2xl tw:font-bold">
          {formattedFocusDataNumber} {focusDataUnit}
          {trendIconClass && (
            <i className={cn("tw:text-lg tw:ml-1 trend-icon", trendIconClass)}></i>
          )}
        </div>
        {focusSubtitle && <p className="tw:text-xs tw:text-muted-foreground">{focusSubtitle}</p>}
        {formattedComparisonDataNumber !== null && (
          <div className="tw:text-xl tw:font-bold tw:text-muted-foreground">
            {formattedComparisonDataNumber} {comparisonDataUnit}
          </div>
        )}
        {comparisonSubtitle && (
          <p className="tw:text-xs tw:text-muted-foreground">{comparisonSubtitle}</p>
        )}
      </CardContent>
    </Card>
  );
}
